import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { BellRing, BellOff, ChevronDown, ChevronRight } from "lucide-react";

const OFF_LABEL = { assigned: "assignments", status: "status", comment: "comments" };

export default function NotificationDiagnostics() {
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    api.get("/notifications/admin/overview")
      .then((r) => setData(r.data))
      .catch(() => setData(null));
  }, []);

  if (!data) return null;

  const rows = (data.members || []).filter((m) => m.active !== false || m.devices > 0);
  const on = data.enabled_count || 0;

  return (
    <div className="bg-white border border-zinc-200 mb-4" data-testid="notification-diagnostics">
      <button
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center justify-between gap-3 px-5 py-3.5 text-left hover:bg-zinc-50 transition-colors"
        data-testid="notification-diagnostics-toggle"
      >
        <div className="flex items-center gap-2.5 min-w-0">
          <span className="h-8 w-8 shrink-0 rounded-sm bg-zinc-900 text-white flex items-center justify-center">
            <BellRing className="h-4 w-4" />
          </span>
          <div className="min-w-0">
            <p className="text-sm font-semibold leading-tight">Desktop notifications</p>
            <p className="text-xs text-zinc-500 leading-tight mt-0.5">
              <span className="font-semibold text-zinc-900" data-testid="notif-diag-count">{on}</span> of {rows.length} teammates will receive push alerts
            </p>
          </div>
        </div>
        {open ? <ChevronDown className="h-4 w-4 text-zinc-400 shrink-0" /> : <ChevronRight className="h-4 w-4 text-zinc-400 shrink-0" />}
      </button>

      {open && (
        <div className="border-t border-zinc-200">
          {rows.map((m) => {
            const offEvents = Object.entries(m.preferences || {})
              .filter(([, v]) => !v)
              .map(([k]) => OFF_LABEL[k] || k);
            const enabled = m.devices > 0;
            return (
              <div
                key={m.user_id}
                className="flex items-center justify-between gap-3 px-5 py-3 border-b border-zinc-100 last:border-0"
                data-testid={`notif-diag-row-${m.user_id}`}
              >
                <div className="min-w-0">
                  <p className="text-sm font-medium leading-tight truncate">{m.name || m.email}</p>
                  <p className="text-[11px] text-zinc-500 leading-tight truncate">
                    {m.email}
                    {offEvents.length > 0 && (
                      <span className="text-amber-600"> · muted: {offEvents.join(", ")}</span>
                    )}
                  </p>
                </div>
                {enabled ? (
                  <span className="shrink-0 inline-flex items-center gap-1.5 text-[11px] font-semibold px-2.5 py-1 rounded-sm bg-emerald-50 text-emerald-700 border border-emerald-200">
                    <BellRing className="h-3 w-3" /> On · {m.devices} device{m.devices === 1 ? "" : "s"}
                  </span>
                ) : (
                  <span className="shrink-0 inline-flex items-center gap-1.5 text-[11px] font-semibold px-2.5 py-1 rounded-sm bg-zinc-100 text-zinc-500 border border-zinc-200">
                    <BellOff className="h-3 w-3" /> Off
                  </span>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
